var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMozambiqueIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10239_105621)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10239_105621",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 81,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H80.0039V60H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10239_105621)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H90V18.75H0V0Z",
    fill: "#009A00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18.75H90V20.625H0V18.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 20.625H90V39.375H0V20.625Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 39.375H90V41.25H0V39.375Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 41.25H90V60H0V41.25Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V60L39.375 30L0 0Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2617 39.0234L17.2617 34.6289L11.2617 39.0234L13.5938 31.957L7.55859 27.6094L15 27.6328L17.2617 20.5547L19.5352 27.6445L26.9766 27.6094L20.9414 31.957L23.2617 39.0234Z",
    fill: "#FFCA00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0469 34.0898H16.3828C16.7344 34.4766 17.4961 34.6406 18.2344 34.0898C19.5938 33.3398 22.2188 34.0898 22.2188 34.0898L22.7344 33.5391L21.4805 29.4141L21.0234 28.9219C21.0234 28.9219 20.0508 28.3359 18.2109 28.5352C16.3711 28.7344 15.7266 28.4766 15.7266 28.4766C15.7266 28.4766 14.1211 28.6641 13.6641 28.8984L13.1484 29.4141L12.0469 34.0898Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.128906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9258 33.0233C12.9258 33.0233 17.0508 32.5077 18.2461 34.0897C17.5781 34.5585 16.9805 34.5936 16.3477 34.1249C16.4414 33.9491 17.8242 32.5077 21.3516 32.9882",
    stroke: "black",
    strokeWidth: 0.128906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3438 28.8984L17.3086 33.4453M21.0234 28.957L21.7969 32.5781",
    stroke: "black",
    strokeWidth: 0.140625
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7109 28.8984L13.2773 30.7734",
    stroke: "black",
    strokeWidth: 0.128906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24609 34.582L10.2539 35.7773C10.3711 35.8477 10.4883 35.8477 10.5937 35.7773L12.0937 33.9727L12.7266 33.1875C12.832 33.0703 12.8555 32.9414 12.8437 32.8359L14.0625 31.7461L14.3203 31.7695C14.2031 31.7461 14.1211 31.6875 14.2031 31.5586L14.4844 31.3477L14.6953 31.6172C14.6953 31.6172 14.3906 32.0156 14.3555 32.0156H14.0273L13.3945 32.5898L13.6758 32.8242L14.0859 33.9727L14.6016 33.6094L14.2734 32.4375L14.9883 31.6523L14.7187 31.2305L14.9062 30.9961C14.9062 30.9961 17.4023 32.5664 18.375 32.1445C18.3984 32.1445 18.4336 31.0195 18.4336 31.0195C18.4336 31.0195 15.832 30.75 15.7734 30.2344C15.7148 29.7188 16.3594 29.6484 16.3594 29.6484L16.0781 29.2734L16.1367 29.0625L16.5938 29.625L17.6133 28.7578L23.6484 35.625C23.9766 35.4961 24.0469 35.4141 24.0703 35.0859L18.1641 28.3008L18.6094 27.8203C18.7031 27.7148 18.7266 27.6797 18.7266 27.5156L19.4297 26.918C19.6138 26.9811 19.7709 27.1051 19.875 27.2695L21.7969 25.6641C21.8437 25.7109 21.9961 25.7578 22.1016 25.7109L25.2539 22.6758L21.8203 25.1016L21.7031 25.0195C21.7031 24.9141 21.8203 24.9023 21.7031 24.7148C21.5625 24.5508 21.3633 24.8672 21.3398 24.8672C21.3047 24.8672 20.8359 24.7031 20.7305 24.4922L20.707 25.043L19.8281 25.8633L19.1602 25.8281L18.1992 26.7656L18.082 27.1172L18.2344 27.4336C18.2344 27.4336 17.7187 27.8789 17.7187 27.8555C17.7187 27.8203 17.6133 27.7148 17.6016 27.7031L18.0469 27.3047L18.1055 27.0352L17.9648 26.8008C17.918 26.8359 17.3555 27.4336 17.3203 27.3633L15.6797 25.5469L15.7734 25.207L14.7539 24.0938C14.3789 23.9648 13.7812 23.9414 13.6641 24.7617C13.5703 24.9492 12.7969 24.7852 12.7969 24.7852L12.375 24.8789L9.98437 28.2422L11.3086 29.8359L14.0273 26.4023L14.1094 25.4297L14.6719 26.0625C14.8711 26.0859 15.0469 26.0977 15.2227 26.0039L16.8281 27.7969L16.5586 28.0664L16.793 28.3242L17.0742 28.1367L17.1797 28.2891C17.0508 28.3594 16.9453 28.4648 16.8164 28.5352C16.6055 28.3945 16.3945 28.2188 16.4062 27.9492L15.5039 28.6992L15.4687 28.8398L12.7852 31.0664L12.5508 31.1016L12.4922 31.8047L14.2383 30.3516V30.1406L14.4141 30.293L15.7734 29.2031C15.7734 29.2031 15.8672 29.3203 15.832 29.3203C15.7969 29.3203 14.625 30.4102 14.625 30.4102L14.6016 30.5273L14.3906 30.7148L14.2734 30.6211L12.6328 32.0742H12.3984L11.4961 32.9766C11.2617 33 11.0625 33.0234 10.8633 33.1523L9.24609 34.582Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.128906,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10239_105621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMozambiqueIcon);
export default __webpack_public_path__ + "static/media/mozambiqueIcon.b11a36653ba8c863aeffaac944a8b110.svg";
export { ForwardRef as ReactComponent };